import { defineMessages } from "react-intl"
import { INVENTORY_TAB, STOCK_IMPORT_STATUS } from "../../common/types/inventory"


export const TAB_MESSAGES = defineMessages({
    [INVENTORY_TAB.SETTINGS]: {
        id: "inventory.components.tabs_component.settings_tab",
        defaultMessage: "Settings"
    },
    [INVENTORY_TAB.STOCK_LOCATIONS]: {
        id: "inventory.components.tabs_component.stock_locations_tab",
        defaultMessage: "Stock Locations"
    },
    [INVENTORY_TAB.STOCK_CONTROL]: {
        id: "inventory.components.tabs_component.stock_control_tab",
        defaultMessage: "Stock Control"
    },
    [INVENTORY_TAB.DOCUMENT_TYPES]: {
        id: "inventory.components.tabs_component.documents_types_tab",
        defaultMessage: "Document Types"
    },
    [INVENTORY_TAB.STOCK_DOCUMENTS]: {
        id: "inventory.components.tabs_component.stock_documents_tab",
        defaultMessage: "Stock Documents"
    },
    [INVENTORY_TAB.IMPORTS]: {
        id: "inventory.components.tabs_component.imports_tab",
        defaultMessage: "Imports"
    },
})

export const SETTINGS_PAGE_MESSAGES = defineMessages({
    header: {
        id: "inventory.pages.settings_page.header",
        defaultMessage: "Inventory Settings"
    }
})

export const STOCK_LOCATIONS_PAGE_MESSAGES = defineMessages({
    header: {
        id: "inventory.pages.stock_locations_page.header",
        defaultMessage: "Stock Locations"
    }
})

export const STOCK_CONTROL_PAGE_MESSAGES = defineMessages({
    header: {
        id: "inventory.pages.stock_control_page.header",
        defaultMessage: "Stock Control"
    }
})

export const STOCK_DOCUMENTS_PAGE_MESSAGES = defineMessages({
    header: {
        id: "inventory.pages.stock_documents_page.header",
        defaultMessage: "Stock Documents"
    },
    searchPlaceHolder: {
        id: "stock_document_listing.listing.placeholder.search_stock_documents",
        defaultMessage: "Search stock documents...",
    },
})

export const CREATE_NEW_STOCK_LOCATION_PAGE_MESSAGES = defineMessages({
    mainLabel: {
        id: "inventory.pages.stock_locations_page.create_new.header",
        defaultMessage: "Create a new stock location"
    },
    nameLabel: {
        id: "inventory.pages.stock_locations_page.create_new.name_header",
        defaultMessage: "Name"
    },
    namePlaceholder: {
        id: "inventory.pages.stock_locations_page.create_new.name_placeholder",
        defaultMessage: "New stock location"
    },
    nameHint: {
        id: "inventory.pages.stock_locations_page.create_new.name_hint",
        defaultMessage: "Name your stock location"
    },
    nameMissingError: {
        id: "inventory.pages.stock_locations_page.create_new.name_missing.error_message",
        defaultMessage: "Stock location name required"
    },
    locationsMissingError: {
        id: "inventory.pages.stock_locations_page.create_new.locations_missing.error_message",
        defaultMessage: "Minimum 1 location required"
    },
    assignedLocationLabel: {
        id: "inventory.pages.stock_locations_page.create_new.assigned_location_header",
        defaultMessage: "Assigned location"
    },
    assignedLocationHint: {
        id: "inventory.pages.stock_locations_page.create_new.assigned_location_hint",
        defaultMessage: "Select your existing locations to start managing, tracking and recording stock within this new stock location."
    },
    cancelLabel: {
        id: "inventory.pages.stock_locations_page.create_new.cancel_label",
        defaultMessage: "Cancel"
    },
    saveLabel: {
        id: "inventory.pages.stock_locations_page.create_new.save_label",
        defaultMessage: "Save"
    },
    genericErrorMessage: {
        id: "inventory.pages.stock_locations_page.create_new.error_message",
        defaultMessage: "Error creating inventory location, please try again"
    },
    duplicateNameErrorMessage: {
        id: "inventory.pages.stock_locations_page.create_new.duplicate_nameerror_message",
        defaultMessage: "Unable to create inventory location. You already have an inventory location with the same name."
    }
})

export const EDIT_STOCK_LOCATION_PAGE_MESSAGES = defineMessages({
    mainLabel: {
        id: "inventory.pages.stock_locations_page.edit.header",
        defaultMessage: "Edit stock location"
    },
    deleteLabel: {
        id: "inventory.pages.stock_locations_page.edit.delete",
        defaultMessage: "Delete"
    }
})

export const IMPORT_MESSAGES = defineMessages({
    "header_productTitleKeyword": {
        id: "import.adjustment.listing.header_productTitleKeyword",
        defaultMessage: "Product"
    },
    header_createdAt: {
        id: "import.adjustment.listing.header_import_date",
        defaultMessage: "Import date"
    },
    header_quantity: {
        id: "import.adjustment.listing.header_quantity",
        defaultMessage: "Adjustment"
    },
    header_initialQuantity: {
        id: "import.adjustment.listing.header_initial_quantity",
        defaultMessage: "Previous Quantity"
    },
    header_finalQuantity: {
        id: "import.adjustment.listing.header_final_quantity",
        defaultMessage: "New Quantity"
    },
    search_placeholder: {
        id: "import.adjustment.listing.search_placeholder",
        defaultMessage: "Search a payment...",
    },
})

export const ADJUSTMENT_MESSAGES = defineMessages({
    header_createdAt: {
        id: "stock.adjustment.listing.header_import_date",
        defaultMessage: "Date"
    },
    header_quantity: {
        id: "stock.adjustment.listing.adjustment",
        defaultMessage: "Adjustment"
    },
    header_document: {
        id: "stock.adjustment.listing.header_document",
        defaultMessage: "Document"
    },
    search_placeholder: {
        id: "stock.adjustment.listing.search_placeholder",
        defaultMessage: "Search an adjustment...",
    },
    header_description: {
        id: "stock.adjustment.listing.description",
        defaultMessage: "Description"
    }
})


export const ENABLE_MODULE_SECTION_MESSAGES = defineMessages({
    toggleText: {
        id: "inventory.sections.enable_module_section.toggle_text",
        defaultMessage: "Inventory Module"
    },
    toggleDescription: {
        id: "inventory.sections.enable_module_section.toggle_description",
        defaultMessage: "Click the toggle to enable or disable inventory tracking of your current stock."
    }
})

export const COST_METHOD_SECTION_MESSAGES = defineMessages({
    header: {
        id: "inventory.sections.cost_method_section.toggle_text",
        defaultMessage: "Select your calculation method:"
    },
})

export const DOCUMENT_TYPE_SELECT_SECTION_MESSAGES = defineMessages({
    header: {
        id: "inventory.sections.document_type_select_section.dropdown_header",
        defaultMessage: "Document Type"
    },
    description: {
        id: "inventory.sections.document_type_select_section.dropdown_description",
        defaultMessage: "You may choose any of the default documents to record and track changes in stock inventory."
    }
})

export const DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES = defineMessages({
    name: {
        id: "inventory.sections.document_types_description_tab.name",
        defaultMessage: "Name"
    },
    nameDescription: {
        id: "inventory.sections.document_types_description_tab.name_description",
        defaultMessage: "This name represents the type of the stock document."
    },
    direction: {
        id: "inventory.sections.document_types_description_tab.direction",
        defaultMessage: "Inventory Direction"
    },
    directionDescription: {
        id: "inventory.sections.document_types_description_tab.direction_description",
        defaultMessage: "This defines if the stock will arrive IN the inventory or will leave OUT of the inventory."
    },
    prefix: {
        id: "inventory.sections.document_types_description_tab.prefix",
        defaultMessage: "Prefix"
    },
    prefixDescription: {
        id: "inventory.sections.document_types_description_tab.prefix_description",
        defaultMessage: "This will prefix every document number of theis type."
    },
    requiresContact: {
        id: "inventory.sections.document_types_description_tab.requires_contact",
        defaultMessage: "Requires a Contact"
    },
    requiresContactDescription: {
        id: "inventory.sections.document_types_description_tab.requires_contact_description",
        defaultMessage: "This will allow you to assign a contact to the component and send it online."
    },
    documentColor: {
        id: "inventory.sections.document_types_description_tab.document_color",
        defaultMessage: "Document Color"
    },
    documentColorDescription: {
        id: "inventory.sections.document_types_description_tab.document_color_description",
        defaultMessage: "This document color will display at the form header internally for your staff."
    }
})

export const DOCUMENT_TYPES_STATUS_TAB_MESSAGES = defineMessages({
    description: {
        id: "inventory.sections.document_types_status_tab.description",
        defaultMessage: "Available default statuses for this type of document."
    }
})

export const DOCUMENT_TYPE_TEMPLATE_TAB_MESSAGES = defineMessages({
    description: {
        id: "inventory.sections.document_types_template_tab.description",
        defaultMessage: "Edit available templates."
    },
    documentTemplate: {
        id: "inventory.sections.document_types_template_tab.document_template",
        defaultMessage: "Document Template"
    },
    emailTemplate: {
        id: "inventory.sections.document_types_template_tab.email_template",
        defaultMessage: "Email Template"
    }
})

export const STOCK_IMPORT_PAGE_MESSAGES = defineMessages({
    header: {
        id: "inventory.pages.stock_imports_page.page_header",
        defaultMessage: "Imports"
    },
    importStockButton: {
        id: "inventory.pages.stock_imports_page.import_stock_button",
        defaultMessage: "New Import"
    }
})

export const STOCK_IMPORTS_LISTING_SECTION_MESSAGES = defineMessages({
    searchPlaceHolder: {
        id: "inventory.pages.stock_imports_listing_section.search_placeholder",
        defaultMessage: "Search imports..."
    },
    id: {
        id: "inventory.pages.stock_imports_listing_section.id",
        defaultMessage: "ID"
    },
    createdAt: {
        id: "inventory.pages.stock_imports_listing_section.date",
        defaultMessage: "Date"
    },
    inventoryLocationId: {
        id: "inventory.pages.stock_imports_listing_section.location",
        defaultMessage: "Location"
    },
    status: {
        id: "inventory.pages.stock_imports_listing_section.status",
        defaultMessage: "Status"
    },
    importType: {
        id: "inventory.pages.stock_imports_listing_section.type",
        defaultMessage: "Type"
    }
})

export const STOCK_IMPORTS_LISTING_STATUS_MESSAGES = defineMessages({
    [STOCK_IMPORT_STATUS.IN_PROGRESS]: {
        id: "inventory.components.import_status_component.in_progress",
        defaultMessage: "In Progress"
    },
    [STOCK_IMPORT_STATUS.COMPLETED]: {
        id: "inventory.components.import_status_component.completed",
        defaultMessage: "Completed"
    },
    [STOCK_IMPORT_STATUS.CREATED]: {
        id: "inventory.components.import_status_component.created",
        defaultMessage: "Created"
    },
    [STOCK_IMPORT_STATUS.ERROR]: {
        id: "inventory.components.import_status_component.error",
        defaultMessage: "Error"
    },
})

export const STOCK_IMPORT_MODAL_MESSAGES = defineMessages({
    title: {
        id: "inventory.components.stock_imports_modal.modal_title",
        defaultMessage: "New Inventory Import"
    },
    closeButton: {
        id: "inventory.components.stock_imports_modal.close_btn_label",
        defaultMessage: "Close"
    },
    startImportButton: {
        id: "inventory.components.stock_imports_modal.start_import_btn_label",
        defaultMessage: "Start Import"
    },
    requiredFieldError: {
        id: "inventory.components.stock_imports_modal.required_field_error",
        defaultMessage: "*Required field"
    },
    importTypeSupplierCost: {
        id: "inventory.components.stock_imports_modal.import_type.supplier_cost",
        defaultMessage: "Supplier costs"
    },
    importTypeInventoryLevel: {
        id: "inventory.components.stock_imports_modal.import_type.inventory_level",
        defaultMessage: "Inventory levels"
    }
})

export const STOCK_IMPORT_FORM_MESSAGES = defineMessages({
    stockLocationLabel: {
        id: "inventory.forms.stock_import_form.inventory_location_label",
        defaultMessage: "Stock Location"
    },
    inventoryLocationPlaceholder: {
        id: "inventory.forms.stock_import_form.inventory_location_placeholder",
        defaultMessage: "Select..."
    },
    notesLabel: {
        id: "inventory.forms.stock_import_form.notes_label",
        defaultMessage: "Notes"
    },
    notesPlaceholder: {
        id: "inventory.forms.stock_import_form.notes_placeholder",
        defaultMessage: "Initial import"
    },
    downloadCsvTemplate: {
        id: "inventory.forms.stock_import_form.download_template",
        defaultMessage: "Download CSV template"
    },
    importType: {
        id: "inventory.forms.stock_import_form.import_type",
        defaultMessage: "Import type"
    },
    importFrom : {
        id: "inventory.forms.stock_import_form.import_from",
        defaultMessage: "Import from"
    },
    fromCsv: {
        id: "inventory.forms.stock_import_form.import_from.csv",
        defaultMessage: "CSV"
    },
    fromIntegration: {
        id: "inventory.forms.stock_import_form.import_from.integration",
        defaultMessage: "Integration"
    },
})


export const STOCK_IMPORT_FORM_INTEGRATION_MESSAGES = defineMessages({
    wix: {
        id: "inventory.forms.stock_import_form.integration.wix",
        defaultMessage: "Wix"
    },
    freshbooks: {
        id: "inventory.forms.stock_import_form.integration.freshbooks",
        defaultMessage: "FreshBooks"
    },
})

export const CONTROL_PANEL_MESSAGES = defineMessages({
    btnText: {
        id: "inventory.components.control_panel.btn_text",
        defaultMessage: "New Stock Movement"
    }
})

export const NEW_STOCK_MOVEMENT_MODAL_MESSAGES = defineMessages({
    header: {
        id: "inventory.modals.new_stock_movement_modal.header",
        defaultMessage: "New Stock Movement"
    },
    confirm_btn: {
        id: "inventory.modals.new_stock_movement_modal.confirm_btn",
        defaultMessage: "Create Document"
    },
    documentTypeLabel: {
        id: "inventory.modals.new_stock_movement_modal.document_type_label",
        defaultMessage: "Stock Document Type"
    },
    locationLabel: {
        id: "inventory.modals.new_stock_movement_modal.location_label",
        defaultMessage: "Stock Location"
    },
    contactLabel: {
        id: "inventory.modals.new_stock_movement_modal.supplier_label",
        defaultMessage: "Select a supplier"
    },
    contactDropdownLabel: {
        id: "inventory.modals.new_stock_movement_modal.contact_select_label",
        defaultMessage: "Select..."
    }
})

export const STOCK_DOCUMENT_FOOTER_MESSAGES = defineMessages({
    archivedMsg: {
        id: "inventory.components.stock_document_footer.archived_msg",
        defaultMessage: "This stock document is archived and can't be found in search results."
    },
    openButtonText: {
        id: "inventory.components.stock_document_footer.open_btn_text",
        defaultMessage: "Open Document"
    },
    receiveItems: {
        id: "inventory.components.product_movement_button.receive_items",
        defaultMessage: "Receive Items"
    },
    sendItems: {
        id: "inventory.components.product_movement_button.send_items",
        defaultMessage: "Send Items"
    },
})


export const STOCK_DOCUMENT_MOVEMENT_MODAL_MESSAGES = defineMessages({
    item: {
        id: "inventory.components.product_movement_modal.item",
        defaultMessage: "Item"
    },
    quantityToSend: {
        id: "inventory.components.product_movement_modal.quantity_returned",
        defaultMessage: "Quantity returned"
    },
    quantitySent: {
        id: "inventory.components.product_movement_modal.quantity_sent",
        defaultMessage: "Quantity sent"
    },
    quantityToReceive: {
        id: "inventory.components.product_movement_modal.quantity_requested",
        defaultMessage: "Quantity requested"
    },
    quantityReceived: {
        id: "inventory.components.product_movement_modal.quantity_received",
        defaultMessage: "Quantity received"
    },
    quantityToAdjusted: {
        id: "inventory.components.product_movement_modal.quantity_to_adjust",
        defaultMessage: "Quantity to adjust"
    },
    receiveAll: {
        id: "inventory.components.product_movement_modal.receive_all",
        defaultMessage: "Receive All"
    },
    sendAll: {
        id: "inventory.components.product_movement_modal.send_all",
        defaultMessage: "Send All"
    },
    receiveItems: {
        id: "inventory.components.product_movement_modal.receive_items",
        defaultMessage: "Receive Items"
    },
    sendItems: {
        id: "inventory.components.product_movement_modal.send_items",
        defaultMessage: "Send Items"
    },
    close: {
        id: "inventory.components.product_movement_modal.close",
        defaultMessage: "Close"
    }

})

export const ADD_FROM_ORDER_MODAL_MESSAGES = defineMessages({
    header: {
        id: "inventory.modals.add_from_order_modal.header",
        defaultMessage: "Add products from open orders"
    },
    search_placeholder: {
        id: "inventory.modals.add_from_order_modal.search_placeholder",
        defaultMessage: "Search by order number, customer name, or product name"
    }
})

export const PRODUCT_STOCK_QUANTITIES_LISTING_MESSAGES = defineMessages({
    inventoryReservedHeader: {
        id: "inventory.modals.product_stock_quantities_modal.inventoryReservedHeader",
        defaultMessage: "Current Quantity Reserved"
    },
    inventoryInTransitHeader: {
        id: "inventory.modals.product_stock_quantities_modal.inventoryInTransitHeader",
        defaultMessage: "Current Quantity In Transit"
    }
})

export const STOCK_DOCUMENTS_LISTING_REORDER_POINT_MESSAGES = defineMessages({
    header: {
        id: "inventory.components.stock_documents_listing_reorder_point.header",
        defaultMessage: "Reorder Settings"
    },
    reorderPoint: {
        id: "inventory.components.stock_documents_listing_reorder_point.reorder_point",
        defaultMessage: "Reorder Point"
    },
    reorderQuantity: {
        id: "inventory.components.stock_documents_listing_reorder_point.reorder_quantity",
        defaultMessage: "Reorder Quantity"
    }
})

export const REORDER_BANNER_MESSAGES = defineMessages({
    productText: {
        id: "inventory.section.reorder_banner.product_text",
        defaultMessage: "{amount} products to reorder"
    },
    quickReorderText: {
        id: "inventory.section.reorder_banner.quick_reorder_text",
        defaultMessage: "Quick reorder for {location}",
    },
})


export const REORDER_MODAL_MESSAGES = defineMessages({
    header: {
        id: "inventory.section.reorder_modal.header",
        defaultMessage: "Reorder settings for {location}"
    },
    selectText: {
        id: "inventory.section.reorder_modal.select_text",
        defaultMessage: "Select a supplier to reorder from: ",
    },
    reorderButton: {
        id: "inventory.section.reorder_modal.reorder_button",
        defaultMessage: "Reorder",
    }
})


// WEBPACK FOOTER //
// ./src/utils/inventory/messages.ts